import React from 'react';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { IllustrationAndText } from '../../../../components/IllustrationAndText/v2';
import illustrationChat from '../../../../assets/illustrations/health-chat.svg';
import illustrationPetProfile from '../../../../assets/illustrations/health-pet-profile.svg';
import illustrationPhone from '../../../../assets/illustrations/health-phone.svg';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
const HOW_IT_WORKS_ITEMS = [{
  description: 'Register online',
  illustration: illustrationPetProfile,
  illustrationAlt: 'pet profile'
}, {
  description: 'Chat in the app 24/7',
  illustration: illustrationChat,
  illustrationAlt: 'chat bubble'
}, {
  description: 'Return anytime for unlimited access',
  illustration: illustrationPhone,
  illustrationAlt: 'phone'
}];
export const HealthHowItWorksSection = () => <Container pt={['100px', '120px', '40px']} mb={['40px', '60px', '96px']} data-sentry-element="Container" data-sentry-component="HealthHowItWorksSection" data-sentry-source-file="index.tsx">
    <Box width={[1, null, '50%']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <SectionHeading textAlign="start" data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
        How Vet Chat works
      </SectionHeading>

      <Flex alignItems={['center', 'flex-start']} justifyContent={['flex-start', 'flex-start']} flexDirection="column" mt={[0, null, '32px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {HOW_IT_WORKS_ITEMS.map(({
        description,
        illustration,
        illustrationAlt
      }, index) => {
        const key = `IllustrationAndText-${index}`;
        return <IllustrationAndText key={key} descriptionText={description} descriptionTextProps={{
          fontWeight: 'bold'
        }} illustrationSrc={illustration} illustrationAlt={illustrationAlt} illustrationProps={{
          height: '50px'
        }} mt="32px" />;
      })}
      </Flex>
    </Box>
  </Container>;